import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { IPhcInRoomDiningFee, PhcInRoomDining } from '../../classes/phc-app/phc-app';



/**
 * Generated class for the InRoomDiningOrderModal page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'modal-in-room-dining-order',
  templateUrl: 'in-room-dining-order.html',
})
export class InRoomDiningOrderModal {

  order: IrdOrder;
  firstName: string;
  lastName: string;
  room: string;
  ird: PhcInRoomDining;

  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
  ) {
    this.order = navParams.get('order');
    this.ird = navParams.get('ird');
  }

  initialized() {
    return this.order && this.order.ready();
  }

  startOrder() {
    this.order = new IrdOrder(
      this.firstName,
      this.lastName,
      this.room,
      this.ird.fees
    );
    this.close();
  }


  close() {
    this.viewCtrl.dismiss(this.order);
  }


  submitOrder() {
    this.order.complete = true;
    this.close();
  }

  ionViewDidLoad() {
    const order = document.querySelector('modal-in-room-dining-order');

    // @ts-ignore: Typescript Bug
    (order.parentNode as any).classList.add('ird-order-modal-wrapper');
  }

}


export class IrdOrder {

  items: Array<IrdOrderItem>;
  complete: boolean = false;
  comments: string;

  // Fees
  /*
  fees = [
    {
      name: 'Delivery',
      amount: 5
    }
  ];

  /*
  get fees() {
    return
  }
*/

  get fees() {
    return this._fees.map(({ fee_type, fee_amount, fee_label }) => {
      return {
        name: fee_label,
        amount: fee_type === 'percent' ? (this.subtotalAmount() * (fee_amount / 100)) : fee_amount,
      }
    });
  }

  constructor(
    private firstName: string,
    private lastName: string,
    private room: string,
    private _fees:  IPhcInRoomDiningFee[] = [],

  ){
    this.items = [];
  }


  subtotalAmount(): number {
      return this.items.reduce((total, currItem) => total + currItem.total(), 0);
  }

  feesAmount() {
    return this.fees
      .map(fee => fee.amount)
      .reduce((total, curr) => { return total + curr }, 0);
  }

  totalAmount(): number {
    return ((this.subtotalAmount()) + this.feesAmount() + (this.taxAmount()));
  }

  taxAmount(): number {
    return ((this.subtotalAmount() + this.feesAmount()) * 0.13);
  }

  ready() {
    return this.firstName && this.lastName && this.room;
  }

  addItem(item: IrdOrderItem){

    this.items.unshift(item);
    console.log(this.items);
  }

  removeItem(item: IrdOrderItem){
    let ind = this.items.indexOf(item);
    if (ind > -1) {
      return this.items.splice(ind, 1);
    }
  }

  clear() {
    this.firstName = '';
    this.lastName = '';
    this.room = '';
    this.items = [];
  }

  createHtmlDescription() {
    let created = new Date();
    return `
      <h1>Name: ${this.firstName} ${this.lastName}</h1>
      <h2>Room: ${this.room}</h2><br>
      <h2>Order Created: ${created.toLocaleTimeString()} on ${created.toLocaleDateString()}</h2>
      <h1>Order Details:</h1>
      <div>${this.items.map(item => item.createHtmlDescription()).join('\n')}</div>
      <div>Comments: <p>${this.comments || ''}</p></div><br>
      <h1>Order Cost:</h1>
      <p>Subtotal: $${this.subtotalAmount()}</p>
      <p>Taxes: $${this.taxAmount()}</p>
      <h3>Total: $${this.totalAmount()}</h3>
    `;
  }

}


export class IrdOrderItem{

  modifiers: Array<any> = [];
  priceLevel: any;

  constructor(public item: any ){
    this.priceLevel = item.prices[0];
    if (item.modifiers){
      this.modifiers = item.modifiers.map(modifier => new IrdOrderItemModifier(modifier));
    }

  }

  total() {
    if (!this.priceLevel) return 0;
    let base = parseFloat(this.priceLevel.amount);
    let adjustments = this.modifiers.reduce((total, curr) => {
      return total + curr.priceAdjustment();
    }, 0);



    return base + adjustments;
  }

  addToOrder(order: IrdOrder){
    order.addItem(this);
  }

  removeFromOrder(order: IrdOrder){
    order.removeItem(this);
  }

  updateModifier(mod, setting){
    /*
    let ind = this.item.modifiers.indexOf(mod);
    if (ind > -1){
      this.modifiers[ind] = setting;
    }
    */
    console.log(mod);

  }

  createHtmlDescription() {
    return `
      <p>
        <span>${this.item.title}</span>
        <ul>
        ${this.modifiers.map(mod => mod.createHtmlDescription()).join('\n')}
        </ul>
      </p>
    `;
  }
}

export class IrdOrderItemModifier{

  ref: Array<any>;

  label: string;
  type: string;
  allowMultiple: boolean;



  // Choices
  choices: Array<any>;
  selectedChoices: any = null;

  // Add-ons
  addonPriceAdjust: number;
  addonChecked: boolean = false;
  addonQuantity: number = 0;

  constructor(ref: any){
    this.ref = ref;
    this.label = ref.label;
    this.type = ref.acf_fc_layout;
    this.allowMultiple = ref.allow_multiple;
    if(this.type === 'choice'){
      this.choices = ref.choices;
    }else if(this.type === 'add-on'){
      this.addonPriceAdjust = parseFloat(ref.price_adjust);
    }
  }

  priceAdjustment() {
    let adjust = 0;
    if(this.type == 'add-on'){
      if(this.addonChecked) adjust = this.addonPriceAdjust;
      if(this.addonQuantity > 0) adjust = this.addonPriceAdjust * this.addonQuantity;
    }else if(this.type == 'choice' && this.selectedChoices){
      if(this.selectedChoices.price_adjust){
        adjust = parseFloat(this.selectedChoices.price_adjust);
      }else if(this.selectedChoices[0] && this.selectedChoices[0].price_adjust){
        adjust = this.selectedChoices.reduce((prev, curr) => {
          return prev + parseFloat(curr.price_adjust);
        }, 0);
      }
    }

    return adjust;
  }

  createHtmlDescription() {
    if(this.type === 'choice'){
      if(this.allowMultiple){
        return `<li>${this.label}<ul>${this.selectedChoices.map(c => '<li>' + c.choice + '</li>').join('\n')}</ul></li>`;
      }else{
        return `<li>${this.label} - ${this.selectedChoices.choice}</li>`;
      }
    }else if(this.type === 'add-on'){
      if(this.allowMultiple){
        return `<li>${this.label} - ${this.addonQuantity}x</li>`;
      }else{
        return `<li>${this.label}</li>`;
      }
    }
    return '';
  }

}



// WEBPACK FOOTER //
// ./src/pages/in-room-dining/in-room-dining-order.ts